import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import MenuList from '@material-ui/core/MenuList'
import Popover from '@material-ui/core/Popover'
import { ReactComponent as CrossIcon } from 'assets/img/cross.svg'
import { APP_LANGUAGES } from 'constants/index'
import './title-input.scss'
import messages from './translate'

function TitleInput({
  intl: { formatMessage },
  handleTitleClear,
  formState,
  children: childrenList,
  disabled,
  backgroundButton,
}) {
  const [visibleInputs, setVisibleInputs] = useState([])
  const [manuallyAdded, setManuallyAdded] = useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    const titles = []

    if (!formState) {
      return
    }

    Object.keys(formState).forEach(key => {
      const isEnglish = key === 'en'

      if (isEnglish) {
        return
      }

      const title = formState[key]

      if ((title && formState.en !== title) || manuallyAdded.includes(key)) {
        titles.push(key)
      }
    })

    setVisibleInputs([...titles])
  }, [formState])

  const open = Boolean(anchorEl)
  const isAddButtonVisible =
    visibleInputs.length < Object.values(APP_LANGUAGES).length - 1 && !disabled

  return (
    <div className="title-input">
      {childrenList.map(child => {
        const key = child.props.lang
        const { isInvalid } = child.props
        const isEnglish = key === 'en'

        const engInput = (
          <div className={isInvalid ? 'invalid-field-warning' : ''} key={key}>
            {child}
            {isInvalid && (
              <div className="invalid-field-text">
                {formatMessage({ id: 'invalid_empty_value' })}
              </div>
            )}
          </div>
        )

        return isEnglish
          ? engInput
          : visibleInputs.includes(key) && (
              <div className="input-wrapper" key={key}>
                <div className="field-wrapper">{child}</div>
                <div className="cross-icon">
                  <Button
                    size="small"
                    disabled={disabled}
                    onClick={() => {
                      handleTitleClear(key)
                      setVisibleInputs(visibleInputs.filter(k => k !== key))
                      setManuallyAdded(manuallyAdded.filter(k => k !== key))
                    }}>
                    <CrossIcon />
                  </Button>
                </div>
              </div>
            )
      })}
      {isAddButtonVisible && (
        <Button
          onClick={handleClick}
          className={backgroundButton ? 'add-button background' : 'add-button'}>
          + {formatMessage(messages.addTranslation)}
        </Button>
      )}
      <Popover
        id="app-header-menu"
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}>
        <MenuList>
          {Object.values(APP_LANGUAGES).map(({ key }) => {
            const isEnglish = key === 'en'

            return (
              !isEnglish &&
              !visibleInputs.includes(key) && (
                <MenuItem
                  button
                  component="li"
                  key={key}
                  onClick={() => {
                    handleTitleClear(key)
                    setVisibleInputs([...visibleInputs, key])
                    setManuallyAdded([...manuallyAdded, key])
                    handleClose()
                  }}>
                  {formatMessage(messages[key])}
                </MenuItem>
              )
            )
          })}
        </MenuList>
      </Popover>
    </div>
  )
}

TitleInput.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  formState: PropTypes.object.isRequired,
  handleTitleClear: PropTypes.func.isRequired,
}

export default injectIntl(TitleInput)
